import { authFetch } from "~/services/fetch";

export async function getOnMissionReason() {
  const response = await authFetch({
    url: '/on-mission-reason',
    method: 'GET',
  })

  return response.data;
}